import type { ShouldShowAppSaveBarProps } from "./app-save-bar.type";

import { isDebugModeActivated } from "@/config/environmentUtils";
import { TAB_PARAM_KEYS } from "@/constants/TabKeys";

export const logSaveBar = (...args: unknown[]) => {
  if (!isDebugModeActivated("save-bar")) return;
  console.info("[AppSaveBar]", ...args);
};

export const shouldShowAppSaveBar = ({
  ready,
  tabs = [],
  tabKey = TAB_PARAM_KEYS.CONTEXT_TAB_KEY,
  params,
}: ShouldShowAppSaveBarProps): boolean => {
  if (!ready) return false;

  if (!tabs.length) return true;

  const currentTab = params.get(tabKey);

  return !!(currentTab && tabs.includes(currentTab));
};
